import { TicketServiceData } from 'services/Tickets/ticketServiceType';
import {
  FETCH_OPEN_OR_UNREAD_TICKETS,
  FETCH_OPEN_OR_UNREAD_TICKETS_IS_ERROR,
  FETCH_OPEN_OR_UNREAD_TICKETS_IS_PENDING,
  FETCH_TICKET_BY_ID_IS_COMPLETE,
  FETCH_TICKET_BY_ID_IS_ERROR,
  FETCH_TICKET_BY_ID_IS_PENDING,
  FETCH_TICKETS_IS_COMPLETE,
  FETCH_TICKETS_IS_ERROR,
  FETCH_TICKETS_IS_PENDING,
  FILTER_TICKETS,
  REPLY_TICKET,
  SET_TICKET_ATTACHMENTS,
  SORT_TICKETS,
  TicketActions,
  TicketReducerState,
  TOGGLE_TICKET,
} from 'services/Tickets/types';
import { sort } from 'utils/functions';

const INITIAL_STATE = {
  tickets: [],
  attachments: [],
  sortBy: 'updatedAt',
  filterBy: 'ALL',
  sortDirection: 'DESC',
  params: {
    type: 'function',
    sortSearchParam: 'updatedAt',
    sortSearchValue: (item: TicketServiceData) => Math.max(item.updatedAt ?? 0, item.clientLastRepliedAt ?? 0),
  },

  fetchTicketsIsCompleted: false,
  fetchTicketsIsPending: false,
  fetchTicketsIsError: null,

  fetchOpenOrUnreadTicketsIsCompleted: false,
  fetchOpenOrUnreadTicketsIsPending: false,
  fetchOpenOrUnreadTicketsIsError: null,

  fetchTicketByIdIsCompleted: false,
  fetchTicketByIdIsPending: false,
  fetchTicketByIdIsError: null,

  ticket: undefined,
} satisfies TicketReducerState;

const ticketReducer = (previousState: TicketReducerState | undefined, action: TicketActions): TicketReducerState => {
  const state: TicketReducerState = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case FETCH_TICKETS_IS_COMPLETE:
      return {
        ...state,
        tickets: sort(action.data ?? [], {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
          sortSearchValue: state.params?.sortSearchValue ?? state.params?.value,
        }),
        fetchTicketsIsCompleted: true,
        fetchTicketsIsPending: false,
        fetchTicketsIsError: null,
      };
    case FETCH_TICKETS_IS_PENDING:
      return {
        ...state,
        fetchTicketsIsCompleted: false,
        fetchTicketsIsPending: true,
        fetchTicketsIsError: null,
      };
    case FETCH_TICKETS_IS_ERROR:
      return {
        ...state,
        fetchTicketsIsCompleted: true,
        fetchTicketsIsPending: false,
        fetchTicketsIsError: action.error,
      };

    case FETCH_OPEN_OR_UNREAD_TICKETS:
      return {
        ...state,
        tickets: action.data ?? [],
        fetchOpenOrUnreadTicketsIsCompleted: true,
        fetchOpenOrUnreadTicketsIsPending: false,
        fetchOpenOrUnreadTicketsIsError: null,
      };
    case FETCH_OPEN_OR_UNREAD_TICKETS_IS_PENDING:
      return {
        ...state,

        fetchOpenOrUnreadTicketsIsCompleted: false,
        fetchOpenOrUnreadTicketsIsPending: true,
        fetchOpenOrUnreadTicketsIsError: null,
      };
    case FETCH_OPEN_OR_UNREAD_TICKETS_IS_ERROR:
      return {
        ...state,
        fetchOpenOrUnreadTicketsIsCompleted: true,
        fetchOpenOrUnreadTicketsIsPending: false,
        fetchOpenOrUnreadTicketsIsError: action.error,
      };

    case FILTER_TICKETS:
      return {
        ...state,
        filterBy: action.filterBy,
      };
    case SORT_TICKETS:
      return {
        ...state,
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
        params: action.params,
        tickets: sort(state.tickets, {
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
          sortSearchValue: action.params.sortSearchValue ?? action.params.value,
        }),
      };

    case FETCH_TICKET_BY_ID_IS_COMPLETE:
      return {
        ...state,
        ticket: action.data,
        fetchTicketByIdIsCompleted: true,
        fetchTicketByIdIsPending: false,
        fetchTicketByIdIsError: null,
      };
    case FETCH_TICKET_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchTicketByIdIsCompleted: false,
        fetchTicketByIdIsPending: true,
        fetchTicketByIdIsError: null,
      };
    case FETCH_TICKET_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchTicketByIdIsCompleted: false,
        fetchTicketByIdIsPending: false,
        fetchTicketByIdIsError: action.error,
      };

    case TOGGLE_TICKET: {
      if (!state.ticket) {
        // can't update without a ticket
        return state;
      }

      return {
        ...state,
        ticket: {
          ...state.ticket,
          status: state.ticket.status === 'open' ? 'closed' : 'open',
        },
      };
    }

    case REPLY_TICKET:
      return {
        ...state,
        ticket: action.data,
      };

    case SET_TICKET_ATTACHMENTS:
      return {
        ...state,
        attachments: action.files,
      };
    default:
      return state;
  }
};

export default ticketReducer;
